import { render, staticRenderFns } from "./EmbeddedTranscriptionHistoryMedia.vue?vue&type=template&id=0a65a152&"
import script from "./EmbeddedTranscriptionHistoryMedia.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedTranscriptionHistoryMedia.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedTranscriptionHistoryMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
